<template>
  <v-slide-x-reverse-transition mode="out-in">
    <component
      :is="loginPage.component"
      v-if="loginPage && loginPage.component"
      :key="loginPage.id"
      :class="`nx-login-form--${pageId}`"
      v-bind="$attrs"
      v-on="$listeners"
    />
  </v-slide-x-reverse-transition>
</template>

<script>
import { getLoginPageById } from '@/modules/authentication/config/login-pages';

export default {
  name: 'NxAuthLoginPageRouter',
  props: {
    pageId: {
      type: String,
      required: true,
    },
  },
  computed: {
    loginPage() {
      return getLoginPageById(this.pageId);
    },
  },
};
</script>
